import { environment } from 'src/environments/environment';

const CLIENTE_BRAND = {
  isMosten: false,
  logoMenu: 'assets/dynamicLogo/logotipo-header.svg',
  logoHeader: 'assets/dynamicLogo/logotipo-header.svg',
  logoLogin: 'assets/dynamicLogo/logotipo-login.svg',
  logoHome: 'assets/dynamicLogo/logotipo-home.svg',
  favicon: 'assets/dynamicLogo/favicon.svg'
} as const;

const MOSTEN_BRAND = {
  isMosten: true,
  logoMenu: 'assets/brand/mosten/logotipo-white.svg',
  logoHeader: 'assets/brand/mosten/logotipo-color.svg',
  logoLogin: 'assets/brand/mosten/logotipo-white.svg',
  logoHome: 'assets/brand/mosten/logotipo-color.svg',
  favicon: 'assets/brand/mosten/favicon.svg'
} as const;

export const BRAND = environment.brand === 'mosten' ? MOSTEN_BRAND : CLIENTE_BRAND;
